import type { FollowUp } from '@/types/queue'
import { Badge } from '@/components/ui/badge'
import { formatShortDate } from '@/lib/dates'
import ClickableRow from './ClickableRow'

export default function FollowUpRow({ followUp }: { followUp: FollowUp }) {
  const isOverdue = followUp.days_overdue > 0

  return (
    <ClickableRow
      to={`/visits/case/${followUp.last_visit_id}`}
      className="bg-white hover:bg-slate-50"
      aria-label={`${followUp.patient_name} follow-up`}
    >
      <div className="flex flex-col gap-0.5">
        <span className="text-sm font-medium text-slate-900">{followUp.patient_name}</span>
        <span className="text-xs text-slate-500">{followUp.original_condition}</span>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-xs text-slate-500">
          Due: {formatShortDate(followUp.due_date)}
        </span>
        {isOverdue && (
          <Badge variant="destructive">{followUp.days_overdue}d overdue</Badge>
        )}
      </div>
    </ClickableRow>
  )
}
